import {
  CLOSE_DIALOGUE,
  OPEN_DIALOGUE,
} from "../store/dialogue/dialogue.type";

export const handleOpenNew = (dispatch, type) => {
  dispatch({
    type: OPEN_DIALOGUE,
    payload: {
      type: type,
    },
  });

  let dialogueData_ = {
    dialogue: true,
    type: type,
  };
  sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
};

export const handleEdit = (dispatch, type, data) => {
  dispatch({
    type: OPEN_DIALOGUE,
    payload: {
      type: type,
      data: data,
    },
  });

  let dialogueData_ = {
    dialogue: true,
    type: type,
    dialogueData: data,
  };
  sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
};

export const closeDialogue = (dispatch) => {
  dispatch({
    type: CLOSE_DIALOGUE,
    payload: {
      dialogue: false,
    },
  });

  let dialogueData_ = {
    dialogue: false,
    dialogueData: null,
  };
  sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  close;
};
